import {XauditModel} from '../xaudit.model';

export class NotificationMessageDataModel extends XauditModel {
  NmsgID: string;
  morder: number;
  Message: string;
  enumNotificationMsgTypeID: string;
}
